import { z } from "zod";

export const advertisementStatsSchema = z.object({
  serving_hours: z.number().nullable(),
  serving_hours_prev: z.number().nullable(),
  serving_hours_delta: z.number().nullable(),
  serving_hours_percent: z.number().nullable(),

  serving_hours_cnt: z.number().nullable(),
  serving_hours_cnt_prev: z.number().nullable(),
  serving_hours_cnt_delta: z.number().nullable(),
  serving_hours_cnt_percent: z.number().nullable(),
});

export const merchStatsSchema = z.object({
  bsr_rank: z.number().nullable().optional(),
  bsr_rank_prev: z.number().nullable().optional(),
  bsr_rank_delta: z.number().nullable().optional(),
  bsr_rank_percent: z.number().nullable().optional(),

  total_conv_rate: z.number().nullable().optional(),
  total_conv_rate_prev: z.number().nullable().optional(),
  total_conv_rate_delta: z.number().nullable().optional(),
  total_conv_rate_percent: z.number().nullable().optional(),

  profit: z.number().nullable(),
  profit_prev: z.number().nullable(),
  profit_delta: z.number().nullable(),
  profit_percent: z.number().nullable(),

  profit_wo_adspend: z.number().nullable(),
  profit_wo_adspend_prev: z.number().nullable(),
  profit_wo_adspend_delta: z.number().nullable(),
  profit_wo_adspend_percent: z.number().nullable(),

  conversion_same_sku: z.number().nullable(),
  conversion_same_sku_prev: z.number().nullable(),
  conversion_same_sku_delta: z.number().nullable(),
  conversion_same_sku_percent: z.number().nullable(),

  trends_score: z.number().nullable().optional(),
  sales_trend: z.number().nullable().optional(),
  margin_trend: z.number().nullable().optional(),

  profit_per_page_view: z.number().nullable().optional(),
  profit_per_page_view_prev: z.number().nullable().optional(),
  profit_per_page_view_delta: z.number().nullable().optional(),
  profit_per_page_view_percent: z.number().nullable().optional(),

  profit_per_page_view_wo_adspend: z.number().nullable().optional(),
  profit_per_page_view_wo_adspend_prev: z.number().nullable().optional(),
  profit_per_page_view_wo_adspend_delta: z.number().nullable().optional(),
  profit_per_page_view_wo_adspend_percent: z.number().nullable().optional(),

  page_views: z.number().nullable(),
  page_views_prev: z.number().nullable(),
  page_views_delta: z.number().nullable(),
  page_views_percent: z.number().nullable(),

  total_cogs: z.number().nullable(),
  total_cogs_prev: z.number().nullable(),
  total_cogs_delta: z.number().nullable(),
  total_cogs_percent: z.number().nullable(),

  margin: z.number().nullable(),
  margin_prev: z.number().nullable(),
  margin_delta: z.number().nullable(),
  margin_percent: z.number().nullable(),

  margin_wo_adspend: z.number().nullable(),
  margin_wo_adspend_prev: z.number().nullable(),
  margin_wo_adspend_delta: z.number().nullable(),
  margin_wo_adspend_percent: z.number().nullable(),

  roms: z.number().nullable(),
  roms_prev: z.number().nullable(),
  roms_delta: z.number().nullable(),
  roms_percent: z.number().nullable(),

  total_cost: z.number().nullable(),
  total_cost_prev: z.number().nullable(),
  total_cost_delta: z.number().nullable(),
  total_cost_percent: z.number().nullable(),

  total_order_count: z.number().nullable().optional(),
  total_order_count_prev: z.number().nullable().optional(),
  total_order_count_delta: z.number().nullable().optional(),
  total_order_count_percent: z.number().nullable().optional(),

  seo_score: z.number().nullable().optional(),
  seo_score_prev: z.number().nullable().optional(),
  seo_score_delta: z.number().nullable().optional(),
  seo_score_percent: z.number().nullable().optional(),

  buyability_score: z.number().nullable().optional(),
  buyability_score_prev: z.number().nullable().optional(),
  buyability_score_delta: z.number().nullable().optional(),
  buyability_score_percent: z.number().nullable().optional(),

  organic_sales: z.number().nullable().optional(),
  organic_sales_prev: z.number().nullable().optional(),
  organic_sales_percent: z.number().nullable().optional(),
  organic_sales_delta: z.number().nullable().optional(),

  organic_units: z.number().nullable().optional(),
  organic_units_prev: z.number().nullable().optional(),
  organic_units_percent: z.number().nullable().optional(),
  organic_units_delta: z.number().nullable().optional(),

  organic_page_views: z.number().nullable().optional(),
  organic_page_views_prev: z.number().nullable().optional(),
  organic_page_views_percent: z.number().nullable().optional(),
  organic_page_views_delta: z.number().nullable().optional(),

  org_conv_rate: z.number().nullable().optional(),
  org_conv_rate_delta: z.number().nullable().optional(),
  org_conv_rate_prev: z.number().nullable().optional(),
});
